const filterTrucks = function (filterBox) {
  const btns = filterBox.querySelector(".category") ? Array.from(filterBox.querySelectorAll(".category")) : null;
  const dropdown = filterBox.querySelector(".dropdown") ? filterBox.querySelector(".dropdown") : null;

  if (!btns && !dropdown) return;

  // Check for query params
  const slug = getSlug('cat');

  // Buttons scenarios
  if (btns){

    // Scenario 1 - single truck
    if (slug && filterBox.id !== 'truck-filter') {
      clearActives(btns);
      activateItem(btns);
    }

    // Scenario 2 - truck catalog
    if (slug && filterBox.id === 'truck-filter') {
      filter(slug);
      clearActives(btns);
      activateItem(btns);
      setButtonFiltering(btns);
    }

    // Scenario 3 - no slug
    if (!slug) {
      setButtonFiltering(btns)
    }
  }

  // Dropdown scenarios
  if (dropdown){
    const opts = dropdown.querySelector(".d-option") ? Array.from(dropdown.querySelectorAll(".d-option")) : null;

    // Scenario 1 - single truck
    if (slug && filterBox.id !== 'truck-filter') {
      clearActives(opts);
      activateItem(opts);
      setGoToPage(dropdown, opts);
    }

    // Scenario 2 - truck catalog
    if (slug && filterBox.id === 'truck-filter') {
      clearActives(opts);
      activateItem(opts);
      setDropdownFiltering(dropdown);
    }

    // Scenario 3 - no slug
    if (!slug){
      setDropdownFiltering(dropdown);
    }
  }

 /**
 * Helper Functions
 */

 function setGoToPage (dropdown, opts){
  dropdown.onchange = () => {
    let currentOp = opts.filter(op => op.value === dropdown.value);

    if (currentOp && currentOp[0].dataset.link) window.location.href = currentOp[0].dataset.link;
  }
 }

 function setDropdownFiltering(dd){
   dropdown.onchange = function() {
    const val = dropdown.value && dropdown.value != "" ? dropdown.value : "all";
    filter(val);
   };
 }

 function setButtonFiltering(btns){
  btns.map (function (b) {
    b.onclick = function (e) {
      e.preventDefault();
      const val = b.dataset.slug && b.dataset.slug != "" ? b.dataset.slug : "all";
      if (filterBox.id === 'truck-filter') filter(val);
      clearActives(btns);
      b.classList.add("is-active");
    };
  });
 }

 function activateItem(items) {
  items.map (function (i) {
    if (i.dataset.slug === slug) {
      i.classList.add("is-active");
      i.setAttribute('selected', 'selected')
    }
  });
 }

  function getSlug(param) {
    const queryParams = window.location.search;
    const urlParams = queryParams ? new URLSearchParams(queryParams) : null;
    const slug = urlParams ? urlParams.get(param) : null;

    return slug;
  }

  function clearActives(items) {
    items.map(function (i) {
      i.classList.remove("is-active");
    });
  }

  function filter(make) {
    const m = make ? make : null;
    if (!m) return;

    const data = new FormData();
    const filterName = "filter_trucks";
    const resultBox = document.querySelector("#truck-cards");
    const url = "/wp-admin/admin-ajax.php";

    // Set our filter name and the Make
    data.append('action', filterName);
    data.append('make', m);

    fetch(url, {
      method: "POST",
      credentials: 'same-origin',
      body: data
    })
      .then((response) => response.text())
      .then((data) => {
        if (data) {
          resultBox.innerHTML = data;

          equalizer([resultBox]);
        }
      })
      .catch((error) => {
        console.log('[There was an error filtering available trucks ]');
        console.error(error);
      });
  }// filter()
}

document.addEventListener('DOMContentLoaded', (e) => {
  if (document.querySelector("#truck-filter")) filterTrucks(document.querySelector("#truck-filter"));

  if (document.querySelector("#truck-filter-single")) filterTrucks(document.querySelector("#truck-filter-single"));
});